import { EndPoints } from '../api-config';
let SERVER_ADDR_V1 = EndPoints.backendHost;

export const searchCityOrPostalCode = (search) => `${SERVER_ADDR_V1}/PostalCode/search?textSearch=${search}`;